export function deepFreeze<T>(obj: T): T {
	if (obj && typeof obj === 'object') {
		Object.getOwnPropertyNames(obj).forEach((key) => {
			const value = obj[key]

			if (value && typeof value === 'object') {
				deepFreeze(value)
			}
		})
		Object.freeze(obj)
	}

	return obj
}
